var bookshelf = require("../index-extended");
require("./Building");
require("./Meeting");
require("./Mandate");

module.exports = bookshelf.model("Media", {
  entityName: "Media",
  entityTimestampable: true,
  entitySync: true,
  entityUuid: true,

  tableName: "media",
  buildings() {
    return this.hasMany("Building", "media_id");
  },
  // ???: ??
  meetings() {
    return this.morphMany("Meeting", "", [
      "minutes_media_id",
      "presence_media_id",
      "invitation_media_id",
    ]);
  },
  mandates() {
    return this.hasMany("Mandate", "media_id");
  },

  format(attrs) {
    delete attrs["$id"];
    delete attrs["file_as_base64_string"];
    delete attrs["deleted_media"];

    return attrs;
  },
});
